"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7373],{

/***/ 97373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ BlogCardsGridComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/blog-cards-grid/constants.js
var constants = __webpack_require__(72606);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/blog-cards-grid/blog-cards-grid-component.scss.js



var CARD_WIDTH = "".concat(constants/* default.CARD_WIDTH */.Z.CARD_WIDTH, "px");
var StyledBlogCardsGridComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e12ngkod0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;height:100%;margin:auto;display:flex;flex-wrap:wrap;justify-content:center;.blog-card-item-component-wrapper{width:", CARD_WIDTH, ";margin:16px;flex-shrink:0;}@media (max-width:422px){.blog-card-item-component-wrapper{width:300px;}}@media (max-width:332px){.blog-card-item-component-wrapper{width:280px;}}");

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./segments/desktop/constants.js
var desktop_constants = __webpack_require__(73759);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/blog-cards-grid/blog-card-item/blog-card-item-component.scss.js




var IMAGE_HEIGHT = "".concat(constants/* default.IMAGE_HEIGHT */.Z.IMAGE_HEIGHT, "px");
var StyledBlogCardItemComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "eoijidq0"
})("width:100%;height:100%;border-radius:4px;overflow:hidden;background:", colors/* default.white */.Z.white, ";", (0,desktop_constants.getComponentShadow)(), "  &:hover{", (0,desktop_constants.getComponentShadowWithHoverEffect)(), "}display:flex;flex-direction:column;cursor:pointer;text-decoration:none;transition:transform 300ms ease,box-shadow 300ms ease;&:hover{transform:translateY(-10px);}.grid-image-wrapper-component{width:100%;max-height:", IMAGE_HEIGHT, ";overflow:hidden;flex-shrink:0;}.blog-card-item-content{padding:24px 24px 40px 24px;display:flex;flex-direction:column;flex-grow:1;color:", colors/* default.mud */.Z.mud, ";.title-component-wrapper{flex-grow:1;}.blog-footer-wrapper{flex-shrink:0;margin-top:24px;.button-container{width:100%;display:flex;align-items:left;}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image/grid-image.js + 1 modules
var grid_image = __webpack_require__(94351);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title_title = __webpack_require__(91265);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/blog-cards-grid/blog-card-item/blog-card-item-footer/blog-card-item-footer-component.scss.js



var WRITER_AVATAR_IMAGE_HEIGHT = "".concat(constants/* default.WRITER_AVATAR_IMAGE_HEIGHT */.Z.WRITER_AVATAR_IMAGE_HEIGHT, "px");
var WRITER_AVATAR_IMAGE_WIDTH = "".concat(constants/* default.WRITER_AVATAR_IMAGE_WIDTH */.Z.WRITER_AVATAR_IMAGE_WIDTH, "px");
var StyledBlogCardItemFooterComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1eqn3300"
})("display:flex;align-items:center;.picture-component-wrapper{height:", WRITER_AVATAR_IMAGE_HEIGHT, ";width:", WRITER_AVATAR_IMAGE_WIDTH, ";border-radius:50%;overflow:hidden;flex-shrink:0;}.blog-footer-details{display:flex;flex-direction:column;color:", colors/* default.jaco */.Z.jaco, ";font-size:0.8125rem;margin-left:16px;flex-grow:1;.writer-name{}.more-details{display:flex;align-items:center;margin-top:8px;.article-date{}.seperated-dot{height:3px;width:3px;background-color:", colors/* default.jaco */.Z.jaco, ";border-radius:50%;margin:0px 8px;}.minutes-to-read{}}}.social-links{flex-shrink:0;align-self:flex-end;display:flex;opacity:0;transition:opacity 300ms ease;display:none;&.show{opacity:1;}.social-icon-link-component-wrapper{transform:translateY(7px);&:not(:last-child){margin-right:4px;}}}@media (max-width:422px){.social-links{display:none;}}");

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
;// CONCATENATED MODULE: ./static/svg/linkedin2.svg
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgLinkedin2 = function SvgLinkedin2(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        viewBox: "0 0 256 256"
    }, props), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        d: "M58.12 250.688V85.589H3.244v165.099zM30.682 63.048c19.136 0 31.047-12.678 31.047-28.522C61.372 18.326 49.819 6 31.045 6 12.273 6 0 18.326 0 34.526 0 50.37 11.908 63.048 30.324 63.048h.357M88.492 250.688h54.875V158.49c0-4.934.357-9.864 1.806-13.391 3.967-9.859 12.996-20.07 28.156-20.07 19.857 0 27.8 15.14 27.8 37.335v88.324H256v-94.665c0-50.711-27.073-74.308-63.177-74.308-29.604 0-42.6 16.547-49.821 27.818h.367V85.589H88.493c.72 15.492 0 165.099 0 165.099z",
        clipRule: "evenodd"
    })));
};
/* harmony default export */ var linkedin2 = (SvgLinkedin2);

;// CONCATENATED MODULE: ./static/svg/facebook2.svg
var facebook2_path;
function facebook2_extends() {
    facebook2_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return facebook2_extends.apply(this, arguments);
}

var SvgFacebook2 = function SvgFacebook2(props) {
    return /*#__PURE__*/ react.createElement("svg", facebook2_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        viewBox: "0 0 256 256"
    }, props), facebook2_path || (facebook2_path = /*#__PURE__*/ react.createElement("path", {
        d: "M67.129 136.346h28.062v115.525A4.13 4.13 0 0 0 99.32 256h47.579a4.13 4.13 0 0 0 4.129-4.129V136.89h32.26a4.13 4.13 0 0 0 4.102-3.658l4.899-42.53a4.127 4.127 0 0 0-4.101-4.602H151.03V59.44c0-8.037 4.327-12.112 12.863-12.112h24.295a4.13 4.13 0 0 0 4.129-4.13V4.16a4.13 4.13 0 0 0-4.129-4.13h-33.482a33 33 0 0 0-1.534-.03c-5.809 0-26.003 1.14-41.954 15.815-17.674 16.262-15.217 35.733-14.63 39.109v31.175H67.129A4.13 4.13 0 0 0 63 90.23v41.987a4.13 4.13 0 0 0 4.129 4.13"
    })));
};
/* harmony default export */ var facebook2 = (SvgFacebook2);

;// CONCATENATED MODULE: ./static/svg/twitter2.svg
var twitter2_path;
function twitter2_extends() {
    twitter2_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return twitter2_extends.apply(this, arguments);
}

var SvgTwitter2 = function SvgTwitter2(props) {
    return /*#__PURE__*/ react.createElement("svg", twitter2_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        viewBox: "0 0 256 256"
    }, props), twitter2_path || (twitter2_path = /*#__PURE__*/ react.createElement("path", {
        d: "M80.507 231.698c96.604 0 149.442-79.914 149.442-149.216 0-2.27 0-4.53-.153-6.779A106.8 106.8 0 0 0 256 48.557a105 105 0 0 1-30.167 8.251 52.64 52.64 0 0 0 23.091-29.006 105.4 105.4 0 0 1-33.352 12.729 52.6 52.6 0 0 0-29.799-15.84 52.64 52.64 0 0 0-33.304 5.52 52.52 52.52 0 0 0-23.074 24.606 52.4 52.4 0 0 0-3.33 33.544 149.3 149.3 0 0 1-59.96-15.903 149.1 149.1 0 0 1-48.287-38.89 52.4 52.4 0 0 0-5.753 38.219 52.48 52.48 0 0 0 22.014 31.788 52.2 52.2 0 0 1-23.839-6.564v.665a52.4 52.4 0 0 0 11.881 33.212 52.55 52.55 0 0 0 30.257 18.196 52.5 52.5 0 0 1-23.716.9 52.5 52.5 0 0 0 18.688 26.063 52.64 52.64 0 0 0 30.382 10.357 105.5 105.5 0 0 1-65.229 22.494A107 107 0 0 1 0 208.141a148.86 148.86 0 0 0 80.507 23.516"
    })));
};
/* harmony default export */ var twitter2 = (SvgTwitter2);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/blog-cards-grid/blog-card-item/blog-card-item-footer/social-icon-link/social-icon-link-component.scss.js


var border = "1px solid ".concat(colors/* default.border-gray */.Z["border-gray"]);
var StyledSocialIconLinkComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ead53rd0"
})("border:", border, ";border-radius:50%;height:28px;width:28px;display:flex;align-items:center;justify-content:center;.social-icon{height:10px;width:10px;}");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/blog-cards-grid/blog-card-item/blog-card-item-footer/social-icon-link/social-icon-link-component.js







var SocialIconLinkComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SocialIconLinkComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SocialIconLinkComponent);
    function SocialIconLinkComponent() {
        (0,_class_call_check/* default */.Z)(this, SocialIconLinkComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SocialIconLinkComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, Icon = _props.icon, color = _props.color;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSocialIconLinkComponent, {
                    className: "social-icon-link-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                        className: "social-icon",
                        style: {
                            fill: color
                        }
                    })
                });
            }
        }
    ]);
    return SocialIconLinkComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/blog-cards-grid/blog-card-item/blog-card-item-footer/blog-card-item-footer-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}









var SOCIAL_LINKS = [
    {
        icon: linkedin2,
        color: "#006699"
    },
    {
        icon: facebook2,
        color: "#4B69B0"
    },
    {
        icon: twitter2,
        color: "1DA1F2"
    }
];
var BlogCardItemFooterComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BlogCardItemFooterComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BlogCardItemFooterComponent);
    function BlogCardItemFooterComponent() {
        (0,_class_call_check/* default */.Z)(this, BlogCardItemFooterComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(BlogCardItemFooterComponent, [
        {
            key: "renderSocialLinks",
            value: function renderSocialLinks() {
                return SOCIAL_LINKS.map(function(socialLink, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "social-icon-link-component-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialIconLinkComponent, _object_spread({}, socialLink))
                    }, index);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, isCardHoverd = _props.isCardHoverd, writerImageSrc = _props.writerImageSrc, writerName = _props.writerName, articleDate = _props.articleDate, minutesToRead = _props.minutesToRead;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBlogCardItemFooterComponent, {
                    className: "blog-card-item-footer-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "picture-component-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                src: writerImageSrc
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "blog-footer-details",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "writer-name",
                                    children: writerName
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "more-details",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "article-date",
                                            children: articleDate
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "seperated-dot"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "minutes-to-read",
                                            children: minutesToRead
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("social-links", {
                                show: isCardHoverd
                            }),
                            children: this.renderSocialLinks()
                        })
                    ]
                });
            }
        }
    ]);
    return BlogCardItemFooterComponent;
}(react.PureComponent);


// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button.js + 17 modules
var button_button = __webpack_require__(11068);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/blog-cards-grid/blog-card-item/blog-card-item-component.js





function blog_card_item_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function blog_card_item_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            blog_card_item_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var blog_card_item_component_IMAGE_HEIGHT = "100%";
var IMAGE_WIDTH = "100%";
var BlogCardItemComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BlogCardItemComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BlogCardItemComponent);
    function BlogCardItemComponent(props) {
        (0,_class_call_check/* default */.Z)(this, BlogCardItemComponent);
        var _this;
        _this = _super.call(this, props);
        blog_card_item_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onMouseEnter", function() {
            _this.setState({
                isCardHoverd: true
            });
        });
        blog_card_item_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onMouseLeave", function() {
            _this.setState({
                isCardHoverd: false
            });
        });
        blog_card_item_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderFooterIfNeeded", function() {
            var isCardHoverd = _this.state.isCardHoverd;
            var _props = _this.props, footer = _props.footer, hideFooter = _props.hideFooter, buttonConfig = _props.buttonConfig;
            var hasButtonConfig = buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.buttonType;
            if (hideFooter && !hasButtonConfig) return null;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "blog-footer-wrapper",
                children: hasButtonConfig ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "button-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, blog_card_item_component_object_spread({}, buttonConfig))
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogCardItemFooterComponent, _object_spread_props(blog_card_item_component_object_spread({}, footer), {
                    isCardHoverd: isCardHoverd
                }))
            });
        });
        _this.state = {
            isCardHoverd: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(BlogCardItemComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, link = _props.link, image = _props.image, title = _props.title, openInNewTab = _props.openInNewTab, imageMaxHeight = _props.imageMaxHeight;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBlogCardItemComponent, {
                    className: "blog-card-item-component",
                    href: link,
                    target: openInNewTab ? "_blank" : "_self",
                    onMouseEnter: this.onMouseEnter,
                    onMouseLeave: this.onMouseLeave,
                    children: [
                        (image === null || image === void 0 ? void 0 : image.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid-image-wrapper-component",
                            style: {
                                maxHeight: imageMaxHeight
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_image/* default */.Z, _object_spread_props(blog_card_item_component_object_spread({}, image), {
                                height: blog_card_item_component_IMAGE_HEIGHT,
                                width: IMAGE_WIDTH
                            }))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "blog-card-item-content",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "title-component-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, {
                                        title: title,
                                        titleSize: sizes.XS
                                    })
                                }),
                                this.renderFooterIfNeeded()
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return BlogCardItemComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/blog-cards-grid/blog-cards-grid-component.js




function blog_cards_grid_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function blog_cards_grid_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            blog_cards_grid_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function blog_cards_grid_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function blog_cards_grid_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        blog_cards_grid_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var BlogCardsGridComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BlogCardsGridComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BlogCardsGridComponent);
    function BlogCardsGridComponent() {
        (0,_class_call_check/* default */.Z)(this, BlogCardsGridComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(BlogCardsGridComponent, [
        {
            key: "renderBlogCards",
            value: function renderBlogCards() {
                var _props = this.props, gridItems = _props.gridItems, hideFooter = _props.hideFooter, buttonConfig = _props.buttonConfig, imageMaxHeight = _props.imageMaxHeight;
                return gridItems.map(function(gridItem, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "blog-card-item-component-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogCardItemComponent, blog_cards_grid_component_object_spread_props(blog_cards_grid_component_object_spread({}, gridItem), {
                            hideFooter: hideFooter,
                            buttonConfig: buttonConfig,
                            imageMaxHeight: imageMaxHeight
                        }))
                    }, index);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBlogCardsGridComponent, {
                    className: "blog-cards-grid-component",
                    children: this.renderBlogCards()
                });
            }
        }
    ]);
    return BlogCardsGridComponent;
}(react.PureComponent);

BlogCardsGridComponent.defaultProps = {
    hideFooter: false,
    gridItems: [
        {
            image: {
                src: "/static/img/segment-layout-default-images/grid/painted-people.png"
            },
            title: "New Feature Updates: Check Out Our New Zoom Integration!",
            footer: {
                writerImageSrc: "/static/img/segment-layout-default-images/grid/article-writer-woman.png",
                writerName: "Eliana Atia",
                articleDate: "Mar 12,2020",
                minutesToRead: "3 min read"
            }
        },
        {
            image: {
                src: "/static/img/segment-layout-default-images/grid/monday-zoom-integration.png"
            },
            title: "6 reasons why distributed teams are the future of work",
            footer: {
                writerImageSrc: "/static/img/segment-layout-default-images/grid/article-writer-woman.png",
                writerName: "Eliana Atia",
                articleDate: "Mar 12,2020",
                minutesToRead: "8 min read"
            }
        },
        {
            image: {
                src: "/static/img/segment-layout-default-images/grid/persoon-with-mountain-view.png"
            },
            title: "How Kim Garst rapidly scaled her business",
            footer: {
                writerImageSrc: "/static/img/segment-layout-default-images/grid/article-writer-woman.png",
                writerName: "Eliana Atia",
                articleDate: "Mar 12,2020",
                minutesToRead: "16 min read"
            }
        }
    ],
    paddingTop: 64,
    paddingBottom: 64,
    buttonConfig: {
        buttonType: null
    },
    imageMaxHeight: constants/* default.IMAGE_HEIGHT */.Z.IMAGE_HEIGHT
};


/***/ })

}]);